import { isFeature } from 'Cloud/Application/FeaturesEs6';
import { IS_B2B_BIZ_USER, IS_MY_TEAM, IS_ONPREMISE, IS_PHONE_BROWSER } from 'reactApp/appHelpers/configHelpers';

/** id промо - для включения нужно будет включать фичу 3promo-enable-{id} */
export const PROMO_ID = 'vigbo-print';

/** Ключ для локалстораджа от баннера */
export const storageKeyForBanner = `3promo:${PROMO_ID}`;

const DISABLE_FEATURE = IS_B2B_BIZ_USER || IS_PHONE_BROWSER || IS_ONPREMISE || IS_MY_TEAM;

export const enableRootAlbumVigboPrint = !DISABLE_FEATURE && isFeature(`${PROMO_ID}-enable-root-album`);
export const enableMediaFolderVigboPrint = !DISABLE_FEATURE && isFeature(`${PROMO_ID}-enable-media-folder`);
export const enableAlbumsBadgeVigboPrint = !DISABLE_FEATURE && isFeature(`${PROMO_ID}-enable-albums-badge`);
